export enum RecommendationsQueries {
  RecommendationsTable = 'recommendationsTable',
}
